import { getFormattedPrice } from "../../../../assets/js/get-formatted-price";
import { getDate } from "../../../../assets/js/date-time-converter";

const CourseStartDate = ({ cartItem, textsMapping }) => {
  if (cartItem === undefined) {
    return null;
  }

  const { availableStartDates, selectedCourseId } = cartItem;
  const selectedCourseStartDateObject = availableStartDates.find(
    ({ courseId }) => courseId === selectedCourseId
  );

  if (selectedCourseStartDateObject === undefined) {
    return null;
  }

  const selectedCourseStartDate = getDate(
    selectedCourseStartDateObject.startDateList[0].startTime
  );

  return (
    <span className="order-summary__selected-date">
      {textsMapping.orderSummaryStartOn} {selectedCourseStartDate}
    </span>
  );
};

const OrderSummaryItems = ({
  lineItems,
  checkDiscountActive,
  textsMapping,
  includeVAT = false,
}) => {
  return (
    <div className="order-summary__items">
      {lineItems.map((cartItem) => (
        <div className="order-summary__row" key={cartItem.sku}>
          <div className="order-summary__row-inner">
            <div className="order-summary__label">
              <span className="order-summary__product-title">
                {cartItem.title}
              </span>
              <CourseStartDate
                cartItem={cartItem}
                textsMapping={textsMapping}
              />
            </div>

            <div
              className={`order-summary__price ${
                checkDiscountActive ? "color--primary" : ""
              }`}
            >
              €
              {includeVAT
                ? getFormattedPrice(
                    cartItem.prices.totalPrice + cartItem.prices.vatTotal
                  )
                : getFormattedPrice(cartItem.prices.totalPrice)}
            </div>
          </div>
          {cartItem.hasAlreadyBeenPurchased && (
            <div className="order-summary__product-already-purchased">
              {textsMapping.orderSummaryHasAlreadyBeenPurchasedText}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export { OrderSummaryItems };
